module.exports = __webpack_public_path__ + "fonts/Inter-Medium.9053572.woff";